import { render, staticRenderFns } from "./StarbucksHome.vue?vue&type=template&id=44b140fa"
import script from "./StarbucksHome.vue?vue&type=script&lang=js"
export * from "./StarbucksHome.vue?vue&type=script&lang=js"
import style0 from "./StarbucksHome.vue?vue&type=style&index=0&id=44b140fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports